<span class="cipo-outlined-label" [title]="heading()">{{ heading() }}</span>
<div class="cipo--flex--row cipo--align--center cipo--gap--sm">
    <div class="cipo--flex--column cipo--flex--1 cipo--overflow--hidden">
        <span class="cipo--text-weight--medium cipo--text--ellipsed" [title]="field().label">
            {{ field().label }}
        </span>
        <div class="cipo--flex--row m-t-sm">
            <cipo-field-type-indicator [field]="field()" size="md" />
        </div>
    </div>
    <div class="field-card__actions">
        <ng-content />
    </div>
</div>
